module.exports = __webpack_public_path__ + "static/media/bgShare1@2x.8c1148bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare1@2x.png
// module id = 884
// module chunks = 0